/**
 * Extracted from snippets/pdp-timer-component-v8.liquid (inline <script> at line 678).
 * Config bridge: window.__nsPdpTimerV8Blocks, keyed by block id. The snippet renders once
 * per block, so the Liquid it needed (the block id and its settings) is now
 * handed over as data and this asset boots once per registered block —
 * same per-instance behaviour, but the code is downloaded once, cached, and
 * kept out of the HTML parse (INP work on the PDP).
 */

(function () {
  var cfg = window.__nsPdpTimerV8Blocks = window.__nsPdpTimerV8Blocks || {};
  // Run now if the document is already parsed (asset executed after
  // DOMContentLoaded: theme-editor section reloads, injected HTML), else wait.
  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }
  function boot(nsBlockId, nsSettings) {
  onReady(function () {
    function timerBlockInit() {
      let blockEl = document.querySelector(`#block-${nsBlockId}`);
  
      // Get settings from the block
      const startTimeString = `${nsSettings.startTime}`; // e.g., "2025-04-22T00:00:00Z"
      const endTimeString = `${nsSettings.endTime}`;   // e.g., "2025-04-23T00:00:00Z"
      const timezoneSetting = `${nsSettings.timeZone}`; // e.g., "EST". This might now be less relevant if inputs are UTC.
      const resetTimer = `${nsSettings.resetTimer}` === 'true';
  
      function createDateObject(dateTimeString, targetTimezoneAbbr) {
          // Check if the string is already in ISO 8601 UTC format
          if (dateTimeString.includes('T') && dateTimeString.endsWith('Z')) {
              // It's already UTC, just parse it directly
              const dateObj = new Date(dateTimeString);
              if (isNaN(dateObj.getTime())) {
                   console.error("Invalid ISO date string provided:", dateTimeString, `for block ${nsBlockId}`);
                   return new Date(); // Fallback
              }
              return dateObj;
          }

          // If not ISO UTC, proceed with the previous logic for "YYYY-MM-DD HH:MM:SS" format
          // This part is for backward compatibility or if some settings still use the old format.
          const parts = dateTimeString.match(/(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})/);
          if (!parts) {
              console.error("Invalid date/time string format (expected YYYY-MM-DD HH:MM:SS or ISO UTC):", dateTimeString, `for block ${nsBlockId}`);
              return new Date(); // Fallback
          }

          const year = parseInt(parts[1], 10);
          const month = parseInt(parts[2], 10) - 1; // JS months are 0-11
          const day = parseInt(parts[3], 10);
          const hour = parseInt(parts[4], 10);
          const minute = parseInt(parts[5], 10);
          const second = parseInt(parts[6], 10);

          // This offset logic is for when the input string (YYYY-MM-DD HH:MM:SS) is for a *specific timezone*
          // and needs conversion to UTC.
          let shopifyTimezoneOffsetMinutes;
          switch (targetTimezoneAbbr) {
              case 'PST': shopifyTimezoneOffsetMinutes = 420; break;
              case 'EST': shopifyTimezoneOffsetMinutes = 240; break;
              case 'UK':  shopifyTimezoneOffsetMinutes = 0; break;
              case 'Europe': shopifyTimezoneOffsetMinutes = -60; break; // CET
              // case 'Europe': shopifyTimezoneOffsetMinutes = -120; break; // CEST if you want to be specific
              default: shopifyTimezoneOffsetMinutes = 0;
          }
          const zoneActualOffsetFromUTCMinutes = -shopifyTimezoneOffsetMinutes;
          const correctUTCMillis = Date.UTC(year, month, day, hour, minute, second) - (zoneActualOffsetFromUTCMinutes * 60000);
          return new Date(correctUTCMillis);
      }
  
      const newStartTime = createDateObject(startTimeString, timezoneSetting);
      const newEndTime = createDateObject(endTimeString, timezoneSetting);

      console.log(`--- Timer Debug Block: ${nsBlockId} ---`);
      console.log("Shopify Raw Settings:", { startTimeString, endTimeString, timezoneSetting });
      console.log("Intended Start Time (UTC):", newStartTime.toUTCString());
      console.log("Intended Start Time (Browser Local):", newStartTime.toString());
      console.log("Intended End Time (UTC):", newEndTime.toUTCString());
      console.log("Intended End Time (Browser Local):", newEndTime.toString());
      console.log("Current Time (UTC):", new Date().toUTCString());
  
      // Timer segments
      let days, hours, minutes, seconds = 0;
      const daysSegment = blockEl.querySelector('#ns-timer-announce-days');
      const hoursSegment = blockEl.querySelector('#ns-timer-announce-hours');
      const minutesSegment = blockEl.querySelector('#ns-timer-announce-minutes');
      const secondsSegment = blockEl.querySelector('#ns-timer-announce-seconds');
      const timeStringEls = blockEl.querySelectorAll('#ns-timer-announce-string');
      const countdownBlock = blockEl.querySelector('#ns-timer-announce-campaign-countdown');
  
      // Format number helper
      function formatNumber(number) {
        return number < 10 ? `0${number}` : number;
      }
  
      // Adjust time for timezone
      // function getNewZoneTime(oldTime, timezoneOffset) {
      //   return new Date(oldTime.getTime() + timezoneOffset * 60000);
      // }
  
      // Reset timer logic
      function getNextResetTime(currentTimeUTC, resetTimezoneAbbr) {
          let targetZoneUTCOffsetMinutes;
          switch (resetTimezoneAbbr) {
              case 'PST': targetZoneUTCOffsetMinutes = -420; break; // Assuming PDT (UTC-7)
              case 'EST': targetZoneUTCOffsetMinutes = -240; break; // Assuming EDT (UTC-4)
              case 'UK':  targetZoneUTCOffsetMinutes = 0;    break; // Assuming GMT (UTC+0) - adjust for BST (UTC+1) if needed
              case 'Europe': targetZoneUTCOffsetMinutes = 60; break; // Assuming CET (UTC+1) - adjust for CEST (UTC+2) if needed
              default: targetZoneUTCOffsetMinutes = 0; // Default to UTC midnight
          }

          const nowInTargetZonePerspective = new Date(currentTimeUTC.getTime() + targetZoneUTCOffsetMinutes * 60000);
          const nextMidnightInTargetZonePerspective = new Date(nowInTargetZonePerspective);
          nextMidnightInTargetZonePerspective.setUTCHours(24, 0, 0, 0); 
          const nextMidnightUTCms = nextMidnightInTargetZonePerspective.getTime() - (targetZoneUTCOffsetMinutes * 60000);

          return new Date(nextMidnightUTCms);
      }
  
      // Update countdown
      function updateCountdown() {
          const currentTime = new Date(); // This is in user's local time, but .getTime() gives UTC ms
          let targetTime = newEndTime;

          if (resetTimer) {
            targetTime = getNextResetTime(currentTime, timezoneSetting);
          }

          const leftTime = targetTime.getTime() - currentTime.getTime();

          // --- Logging inside updateCountdown ---
          if (Math.random() < 0.01) { // Log occasionally, not every second
              console.log(`UpdateCD Block ${nsBlockId}: Target (UTC): ${targetTime.toUTCString()}, Current (UTC): ${currentTime.toUTCString()}, Left: ${leftTime}ms`);
          }
          // --- End Logging ---

          const effectiveLeftTime = Math.max(0, leftTime);

          const days = Math.floor(effectiveLeftTime / 86400000);
          const hours = Math.floor((effectiveLeftTime / 3600000) % 24);
          const minutes = Math.floor((effectiveLeftTime / 60000) % 60);
          const seconds = Math.floor((effectiveLeftTime / 1000) % 60);

          if (daysSegment) daysSegment.textContent = formatNumber(days);
          if (hoursSegment) hoursSegment.textContent = formatNumber(hours);
          if (minutesSegment) minutesSegment.textContent = formatNumber(minutes);
          if (secondsSegment) secondsSegment.textContent = formatNumber(seconds);

          let newTimeStringContent;
          const timerExpiredText = `${nsSettings.expiredText}`;

          if (leftTime <= 0) {
              newTimeStringContent = timerExpiredText;
              clearInterval(updateInterval);
              if (countdownBlock && countdownBlock.style.display !== 'none') {
                  // countdownBlock.style.display = 'none'; // Or update to show expired
              }
          } else if (days > 0) {
              newTimeStringContent = ` ${formatNumber(days)}d ${formatNumber(hours)}h ${formatNumber(minutes)}m`;
          } else if (hours > 0) {
              newTimeStringContent = ` ${formatNumber(hours)}h ${formatNumber(minutes)}m`;
          } else if (minutes > 0) {
              newTimeStringContent = ` ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;
          } else { // Only seconds left, or exactly 0
              newTimeStringContent = ` ${formatNumber(seconds)}s`;
          }
        
          if (timeStringEls && timeStringEls.length > 0) {
              timeStringEls.forEach(el => {
                  // Check if the content actually needs updating to avoid unnecessary DOM manipulation
                  if (el.textContent !== newTimeStringContent) {
                      el.textContent = newTimeStringContent;
                  }
              });
          }
      }

      // Initial check if timer should even run (e.g. if start time is in the future)
      if (new Date().getTime() < newStartTime.getTime()) {
          console.log(`Timer Block ${nsBlockId}: Start time is in the future. Hiding timer or showing 'starts soon'.`);
          if (countdownBlock) countdownBlock.style.display = 'none';
          if (timeStringEls && timeStringEls.length > 0) {
              timeStringEls.forEach(el => el.textContent = `${nsSettings.beforeStartText}`);
          }
          return; // Don't start interval if not yet started
      }
    
      // Initial check if timer has already expired based on non-resetting end time
      if (!resetTimer && new Date().getTime() >= newEndTime.getTime()) {
          console.log(`Timer Block ${nsBlockId}: End time is in the past and no reset. Showing expired.`);
          if (countdownBlock) countdownBlock.style.display = 'none';
          if (timeStringEls && timeStringEls.length > 0) {
               timeStringEls.forEach(el => el.textContent = `${nsSettings.expiredText}`);
          }
          return; // Don't start interval if already ended and no reset
      }
  
      updateCountdown();
      var updateInterval = setInterval(updateCountdown, 1000);
  
      // Initial setup
      // if (new Date() > newStartTime) {
      //   updateCountdown();
      //   var updateInterval = setInterval(updateCountdown, 1000);
      // } else {
      //   countdownBlock.style.display = 'none';
      // }

      // collapsible element inside timer
      let collapsibleEl = document.querySelector('.collapsible-container');
      let collapsibleHeadingEl;
      let collapsibleWrapperEl;

      if (collapsibleEl) {
        collapsibleHeadingEl = collapsibleEl.querySelector('.ns-pdp-timer-comp-v8__collapsible-heading')
        collapsibleWrapperEl = collapsibleEl.querySelector('.wrapper')
      }
      console.log(collapsibleEl, collapsibleHeadingEl, collapsibleWrapperEl)
    
      if (collapsibleHeadingEl) {
        collapsibleHeadingEl.addEventListener('click', () => {
          console.log('clicked')
          collapsibleHandler(collapsibleHeadingEl, collapsibleWrapperEl)
        })
      }

      function collapsibleHandler(heading, wrapper) {
        if (wrapper) {
          collapsibleEl.classList.toggle('is-open')
          wrapper.classList.toggle('is-open')
        }
      }
    }

    timerBlockInit()
  
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        timerBlockInit()
      });
    }
  });
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
